/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from "react";
import TreatmentRecapCard, {
  OtherTherapiesInterface,
} from "../../therapy/OtherGoal";

import AverageOtherGoals from "../../therapy/AverageOtherGoals";
import ActivityManager from "../../home/ActivityManager";
import { ActivityUpdateData } from "../../../types/homeTypes";
import { TherapyItem } from "../../therapy/BiWazeTherapyCard";
import { useIonRouter } from "@ionic/react";
import {
  therapyMockData,
  otherTherapiesHealthMockData,
  treatmentSessionChartMockData,
  AverageMock,
} from "../../../utils/guestHome";

import { close } from "ionicons/icons";
import { RequestPopup } from "./Components/RequestPopup";

// import { ActivityUpdateData } from "../../types/homeTypes";

const GuestGoals: React.FC = () => {
  const [otherTherapies, setOtherTherapies] = useState<
    OtherTherapiesInterface[]
  >([]);
  const [otherTherapiesHealth, setOtherTherapiesHealth] = useState<
    OtherTherapiesInterface[]
  >([]);
  const [treatmentSessionData, setTreatmentSessionData] = useState<any>(null);
  const [averageGoals, setAverageGoals] = useState<any[]>([]);
  const [usageData, setUsageData] = useState<any>(null);
  const [activeModal, setActiveModal] = useState<string | null>(null);
  const [therapyData, setTherapyData] = useState<TherapyItem[]>([]);
  const [isLoginPopupOpen, setIsLoginPopupOpen] = useState(false);
  const Router = useIonRouter();
  const fetchActivityData = async () => {
    if (therapyMockData) {
      setTherapyData(therapyMockData);
    }

    // Health therapies data
    if (otherTherapiesHealthMockData) {
      setOtherTherapiesHealth(otherTherapiesHealthMockData);
    }

    // Treatment session chart data
    if (treatmentSessionChartMockData) {
      setTreatmentSessionData(treatmentSessionChartMockData);
    }

    // Average goals data
    if (AverageMock) {
      setAverageGoals(AverageMock);
    }
  };

  useEffect(() => {
    fetchActivityData();
  }, []);
  // Dummy implementations for required props
  const getCurrentActivityValue = (type: string): number => 0;

  const handleActivityUpdate = async (data: ActivityUpdateData) => {
    console.log("Activity updated:", data);
  };

  return (
    <>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mt-28 px-2 items-start">
        {/* Left Column - Other Treatments */}
        <div>
          {(otherTherapiesHealth.length > 0 || otherTherapies.length > 0) && (
            <div className="col-span-1 mt-[6%]">
              <div className="card-title text-black flex-start p-1 font-bold">
                {/* Goals */}
              </div>
              <div className="p-0.5 m-0.5">
                {[...(otherTherapiesHealth || [])].map(
                  (therapy, index) =>
                    therapy.target && (
                      <TreatmentRecapCard
                        currentUser={true}
                        handleOnClick={() => {
                          setIsLoginPopupOpen(true);
                        }}
                        key={`therapy-${therapy.name}-${index}`}
                        therapy={therapy}
                      />
                    )
                )}
              </div>
            </div>
          )}
        </div>

        {/* Right Column - Chart + Goals + Usage */}
        <div>
          {/* Treatment Session Chart */}
          {/* {treatmentSessionData && (
            <div className="col-span-1">
              <div className="card-title text-black flex-start p-4 font-bold">
                Therapies Overview
              </div>
              <TreatmentSessionChart
                data={treatmentSessionData}
                isBookmarked={false}
                isLiked={false}
                hideFooter={true}
              />
            </div>
          )} */}

          {/* Goals */}
          <div className="card-title text-black flex-start p-4 font-bold">
            Goals
          </div>

          {averageGoals && averageGoals.length > 0 && (
            <div className="col-span-1">
              <AverageOtherGoals goals={averageGoals} />
            </div>
          )}

          <div className="h-4" />
        </div>
      </div>
      {isLoginPopupOpen && (
        <RequestPopup title="Guest View" buttonText="Proceed" onProceed={()=>Router.push('/login')} onClose={() => setIsLoginPopupOpen(false)} />
      )}
      {/* Activity Manager Modal */}
      <ActivityManager.RecordActivityModal
        activeModal={activeModal}
        onClose={() => setActiveModal(null)}
        getCurrentActivityValue={getCurrentActivityValue}
        handleActivityUpdate={handleActivityUpdate}
      />
    </>
  );
};

export default GuestGoals;
